import clsx from 'clsx';

const styles = {
  'Bestseller': 'bg-accent-50 text-accent-700 dark:bg-accent-500/20 dark:text-accent-300',
  'New Release': 'bg-primary-600 text-white dark:bg-primary-500 dark:text-white',
  "Editor's Pick": 'bg-amber-50 text-warning-800 dark:bg-warning/20 dark:text-warning-200',
  'Trending': 'bg-emerald-50 text-success-800 dark:bg-success/20 dark:text-success-200',
  'Free': 'bg-success text-white',
  'Early Access': 'bg-primary-600 text-white dark:bg-primary-500 dark:text-white',
  'Coming Soon': 'bg-slate-700 text-white dark:bg-white/15 dark:text-slate-200',
  'New': 'bg-primary-600 text-white dark:bg-primary-500 dark:text-white',
};

export default function Badge({ children, className, size = 'md' }) {
  return (
    <span
      className={clsx(
        'inline-flex items-center rounded-full font-semibold tracking-wide',
        size === 'sm' ? 'px-1.5 py-0.5 text-[9px]' : 'px-2.5 py-1 text-[11px]',
        styles[children] || 'bg-slate-100 text-slate-600 dark:bg-white/10 dark:text-slate-300',
        className
      )}
    >
      {children}
    </span>
  );
}
